(function () {
  "use strict";

  var STORAGE_KEY = "motordash_google_ads_attribution_v2";
  var LEGACY_KEYS = ["motordash_google_ads_click_ids", "motordash_google_ads_attribution"];
  var CLICK_TYPES = ["gclid", "wbraid", "gbraid"];
  var EXPIRY_MS = 90 * 24 * 60 * 60 * 1000;
  var CART_RESYNC_MS = 6 * 60 * 60 * 1000;

  function now() {
    return Date.now();
  }

  function toIso(timestamp) {
    return new Date(timestamp).toISOString();
  }

  function safeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {}
  }

  function safeRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (_error) {}
  }

  function clean(value) {
    return typeof value === "string" ? value.trim() : "";
  }

  function isLikelyValidClickId(type, value) {
    if (!value) return false;
    return type === "gclid" ? value.length >= 20 : value.length >= 10;
  }

  function readFreshClickId() {
    var params = new URLSearchParams(window.location.search);

    for (var i = 0; i < CLICK_TYPES.length; i += 1) {
      var type = CLICK_TYPES[i];
      var value = clean(params.get(type));

      if (isLikelyValidClickId(type, value)) {
        return { type: type, value: value };
      }
    }

    return null;
  }

  function readStoredAttribution() {
    var raw = safeGet(STORAGE_KEY);
    if (!raw) return null;

    try {
      var attribution = JSON.parse(raw);

      if (!attribution || !isLikelyValidClickId(attribution.type, attribution.value)) {
        safeRemove(STORAGE_KEY);
        return null;
      }

      if (attribution.consumedAt || !attribution.expiresAt || attribution.expiresAt <= now()) {
        safeRemove(STORAGE_KEY);
        return null;
      }

      return attribution;
    } catch (_error) {
      safeRemove(STORAGE_KEY);
      return null;
    }
  }

  function storeFreshAttribution(clickId) {
    var capturedAt = now();
    var attribution = {
      type: clickId.type,
      value: clickId.value,
      capturedAt: capturedAt,
      expiresAt: capturedAt + EXPIRY_MS,
      landingUrl: window.location.href,
      lastCartSyncAt: 0,
      consumedAt: null
    };

    safeSet(STORAGE_KEY, JSON.stringify(attribution));
    return attribution;
  }

  function buildCartAttributes(attribution) {
    var attributes = {
      _gclid: "",
      _gbraid: "",
      _wbraid: "",
      _google_ads_click_id_type: attribution.type,
      _google_ads_click_captured_at: toIso(attribution.capturedAt),
      _google_ads_click_expires_at: toIso(attribution.expiresAt),
      _google_ads_landing_url: attribution.landingUrl || ""
    };

    attributes["_" + attribution.type] = attribution.value;
    return attributes;
  }

  function buildClearAttributes() {
    return {
      _gclid: "",
      _gbraid: "",
      _wbraid: "",
      _google_ads_click_id_type: "",
      _google_ads_click_captured_at: "",
      _google_ads_click_expires_at: "",
      _google_ads_landing_url: ""
    };
  }

  function updateCartAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function isLikelyOrderStatusPage() {
    var path = window.location.pathname.toLowerCase();

    return (
      path.indexOf("/thank_you") !== -1 ||
      path.indexOf("/orders/") !== -1 ||
      (path.indexOf("/checkouts/") !== -1 && path.indexOf("thank_you") !== -1)
    );
  }

  function consumeAttribution() {
    safeRemove(STORAGE_KEY);
    updateCartAttributes(buildClearAttributes()).catch(function () {});
  }

  function run() {
    for (var i = 0; i < LEGACY_KEYS.length; i += 1) {
      safeRemove(LEGACY_KEYS[i]);
    }

    if (isLikelyOrderStatusPage()) {
      consumeAttribution();
      return;
    }

    var freshClickId = readFreshClickId();
    var attribution = freshClickId ? storeFreshAttribution(freshClickId) : readStoredAttribution();

    if (!attribution) return;

    var shouldSyncCart =
      !!freshClickId ||
      !attribution.lastCartSyncAt ||
      now() - attribution.lastCartSyncAt > CART_RESYNC_MS;

    if (!shouldSyncCart) return;

    updateCartAttributes(buildCartAttributes(attribution))
      .then(function () {
        attribution.lastCartSyncAt = now();
        safeSet(STORAGE_KEY, JSON.stringify(attribution));
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();